import type { ParseResult, PositionedText } from "./types";
import { groupIntoLines } from "./pdf/lines";
import { bestTemplate } from "../banks/registry";
import { parseWithTemplate } from "./parser/template";

export class UnknownBankError extends Error {
  constructor() {
    super(
      "Банк не распознан. Отправьте пример выписки — добавим шаблон вашего банка.",
    );
    this.name = "UnknownBankError";
  }
}

/**
 * Convert already-extracted positioned text into a parsed statement.
 * Detection uses the full document text; parsing uses the best template.
 */
export function convertItems(items: PositionedText[]): ParseResult {
  const fullText = groupIntoLines(items)
    .map((l) => l.text)
    .join("\n");

  const template = bestTemplate(fullText);
  if (!template) throw new UnknownBankError();

  return parseWithTemplate(template, items);
}
